"use strict";

exports.__esModule = true;
exports.ConverterType = void 0;
let ConverterType = /*#__PURE__*/function (ConverterType) {
  ConverterType[ConverterType["TO_JSON"] = 0] = "TO_JSON";
  ConverterType[ConverterType["FROM_JSON"] = 1] = "FROM_JSON";
  return ConverterType;
}({});
exports.ConverterType = ConverterType;
//# sourceMappingURL=domain.js.map